(function(L) {
	'use strict';

	L.$chain({
		/**
		 * Determine if an element is currently visible
		 *
		 * @returns {Boolean}
		 */
		visible: function() {
			return L.scroll.visible(this);
		}
	});
})(Apt);